export enum ProductType {
  CILINDER = 'Cilindro',
  TANK = 'Gas estacionario',
}
